/**
 * @flow
 * @relayHash a5b9d164b7e1f078a42e66e41f777fb7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdatePOApprovalRuleInput = {|
  poApprovalRuleId: string,
  minAmount?: ?number,
  maxAmount?: ?number,
  approverUserId?: ?string,
|};
export type UpdatePOApprovalRuleMutationVariables = {|
  input: UpdatePOApprovalRuleInput
|};
export type UpdatePOApprovalRuleMutationResponse = {|
  +updatePOApprovalRule: {|
    +poApprovalRuleEdge: {|
      +node: ?{|
        +id: string,
        +minAmount: ?number,
        +maxAmount: ?number,
        +approver: {|
          +id: string,
          +firstName: string,
          +lastName: string,
          +email: any,
        |},
        +createdAt: any,
      |}
    |}
  |}
|};
export type UpdatePOApprovalRuleMutation = {|
  variables: UpdatePOApprovalRuleMutationVariables,
  response: UpdatePOApprovalRuleMutationResponse,
|};
*/


/*
mutation UpdatePOApprovalRuleMutation(
  $input: UpdatePOApprovalRuleInput!
) {
  updatePOApprovalRule(input: $input) {
    poApprovalRuleEdge {
      node {
        id
        minAmount
        maxAmount
        approver {
          id
          firstName
          lastName
          email
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePOApprovalRuleInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePOApprovalRule",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePOApprovalRulePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poApprovalRuleEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "POApprovalRuleEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "POApprovalRule",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "minAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "maxAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approver",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdatePOApprovalRuleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdatePOApprovalRuleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdatePOApprovalRuleMutation",
    "id": null,
    "text": "mutation UpdatePOApprovalRuleMutation(\n  $input: UpdatePOApprovalRuleInput!\n) {\n  updatePOApprovalRule(input: $input) {\n    poApprovalRuleEdge {\n      node {\n        id\n        minAmount\n        maxAmount\n        approver {\n          id\n          firstName\n          lastName\n          email\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b34711fc2ab6229f461a45e80a207d73';
module.exports = node;
